module.exports = __webpack_public_path__ + "static/media/v.1190511d.svg";